module.exports = __webpack_public_path__ + "img/asana-logo.b13da817.svg";